import React from 'react';
import { motion } from 'framer-motion';
import { LedFrame } from '../ui/LedFrame';
import { LedCar } from './LedCar';
const COVER = 'https://cdn.magicpatterns.com/patterns/generated-images/78916b59-316e-4584-adc2-7d2c0e252d0c.jpg';
const ease = [0.23, 1, 0.32, 1] as const;
export function CatalogCover({
  count
}: {
  count: number;
}) {
  return <LedFrame radius={20} className="bg-ink" data-id="element-407" data-mp="7jhx888s21uq">
      <div className="relative h-[260px] overflow-hidden rounded-[20px] sm:h-[300px]" data-id="element-408" data-mp="3fy02613f91a4">
        <motion.img src={COVER} alt="" className="absolute inset-0 h-full w-full object-cover object-right saturate-[1.2] contrast-[1.08]" initial={{
        scale: 1.06
      }} animate={{
        scale: 1
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-409" data-mp="3azosprh1gssf" />
        <div className="absolute inset-0 bg-ink/35 md:bg-transparent" aria-hidden data-id="element-410" data-mp="1568ae88ud68g" />

        <div className="relative z-10 flex h-full flex-col justify-center px-6 pb-12 sm:px-10" data-id="element-411" data-mp="158b87eg8k3nq">
          <motion.h1 initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          ease
        }} className="text-glow max-w-xl font-display text-3xl font-black uppercase leading-tight tracking-tight underline decoration-neon decoration-4 underline-offset-[10px] sm:text-5xl" data-id="element-412" data-mp="109q7ldx2nhyr">
            Catálogo 0 km multimarca
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          ease,
          delay: 0.08
        }} className="mt-5 max-w-md text-sm text-silver-hi sm:text-base" aria-live="polite" data-id="element-413" data-mp="epox4ys1lqkn">
            <span className="font-bold text-white" data-id="element-414" data-mp="sgtpdft2zgky">{count}</span> {count === 1 ? 'versión lista' : 'versiones listas'} para comparar y financiar.
          </motion.p>
        </div>

        <LedCar data-id="element-415" data-mp="3s28qzt6snjjf" />
      </div>
    </LedFrame>;
}